import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import styled from 'styled-components/native'

import { HOW_ARE_YOU_FEELING_TODAY_MSG, HowAreYouFeelingTodayOption } from '@lyrahealth-inc/shared-app-logic'

import { MoodEmojiLottie } from '../../atoms/moodEmojiLottie/MoodEmojiLottie'
import { MoodEmojiPopInLottie } from '../../atoms/moodEmojiPopInLottie/MoodEmojiPopInLottie'
import { Subhead } from '../../atoms/subhead/Subhead'
import { SubheadSize } from '../../styles/typeStyles'
import { tID } from '../../utils'
import { ThemeType } from '../../utils/themes/ThemeProvider'

const MOOD_LOTTIE_JSON = {
  [HowAreYouFeelingTodayOption.Bad]: require('../../assets/lottie/mood-bad-emoji.json'),
  [HowAreYouFeelingTodayOption.NotGood]: require('../../assets/lottie/mood-notGood-emoji.json'),
  [HowAreYouFeelingTodayOption.Ok]: require('../../assets/lottie/mood-ok-emoji.json'),
  [HowAreYouFeelingTodayOption.Good]: require('../../assets/lottie/mood-good-emoji.json'),
  [HowAreYouFeelingTodayOption.Great]: require('../../assets/lottie/mood-great-emoji.json'),
}

const Container = styled.View<{ containerStyle?: object }>(({ containerStyle }) => ({
  alignItems: 'center',
  ...containerStyle,
}))

const AnimationContainer = styled.View<{ theme: ThemeType; animationContainerStyle?: object }>(
  ({ theme, animationContainerStyle }) => ({
    marginTop: theme.spacing['24px'],
    ...animationContainerStyle,
  }),
)

export interface MoodEmojiDisplayProps {
  currentMoodOption: HowAreYouFeelingTodayOption
  showPopInEmoji?: boolean
  onAnimationFinished?: () => void
  size?: number
  labelSize?: SubheadSize
  containerStyle?: object
  animationContainerStyle?: object
}

export const MoodEmojiDisplay: FunctionComponent<MoodEmojiDisplayProps> = ({
  currentMoodOption,
  showPopInEmoji = false,
  onAnimationFinished = () => {},
  size = 128,
  labelSize = SubheadSize.XSMALL,
  containerStyle = {},
  animationContainerStyle = {},
}) => {
  const intl = useIntl()

  return (
    <Container containerStyle={containerStyle}>
      <AnimationContainer
        testID={tID(`MoodEmoji-${currentMoodOption}`)}
        animationContainerStyle={animationContainerStyle}
      >
        {showPopInEmoji ? (
          <MoodEmojiPopInLottie
            size={size}
            animationSource={MOOD_LOTTIE_JSON[currentMoodOption]}
            handleAnimationFinished={onAnimationFinished}
          />
        ) : (
          <MoodEmojiLottie animationSource={MOOD_LOTTIE_JSON[currentMoodOption]} size={size} />
        )}
      </AnimationContainer>
      <Subhead
        text={intl.formatMessage(HOW_ARE_YOU_FEELING_TODAY_MSG[currentMoodOption])}
        size={labelSize}
        level='3'
        textAlign='center'
      />
    </Container>
  )
}
